import { ArrowChevronDownMiniIcon } from '@calendly/ui/components/icons';
import { primaryColor } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const inputBorderTypeTextareaCss = "i1qydtqm";
const inputBorderTypeSelectCss = "inzf6hs";
const inputBorderTypePhoneCss = "i1sisko4";
const inputBorderCss = "i1dzad82";
const InputBorder = forwardRef((props, ref) => {
  const {
    type,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(inputBorderCss, {
    [inputBorderTypeTextareaCss]: type?.toString() === 'textarea',
    [inputBorderTypeSelectCss]: type?.toString() === 'select',
    [inputBorderTypePhoneCss]: type?.toString() === 'phone'
  }, props.className)} />;
});
const placeholderCss = "pw2ovvq";
const Placeholder = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(placeholderCss, props.className)} />;
});
const iconContainerCss = "i1mofb7n";
const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, props.className)} />;
});
export const InputPreview = ({
  type,
  value,
  placeholder
}) => <InputBorder type={type}>
    {value}
    {!value && placeholder && <Placeholder>{placeholder}</Placeholder>}
    {type === 'select' && <IconContainer>
      <ArrowChevronDownMiniIcon color={primaryColor} />
    </IconContainer>}
    {type === 'phone'}
  </InputBorder>;
const radioPreviewCss = "r1d4a36c";
export const RadioPreview = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(radioPreviewCss, props.className)} />;
});

require("./inputs.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./inputs.js");